<div class="modal-content">
  <div class="modal-header">
    <span class="modal-title">{{ values.title }}</span>
    <div class="go-back">
      <button (click)="dismiss()" class="button" aria-label="Cancel">
        <od-svg-icon class="svg-wrapper" name="icon-times" [parentSize]="true"></od-svg-icon>
      </button>
    </div>
  </div>
  <div class="modal-body">
    <quill-view [content]="values?.description" format="json" theme="snow"></quill-view>
  </div>
  @if (values.confirm) {
    <div class="confirm-block">
      @if (values.confirm.cancel) {
        <div class="confirm-cancel">
          <button (click)="dismiss()" class="confirm-cancel-button">
            {{ values.confirm.cancel }}
          </button>
        </div>
      }
      @if (values.confirm.accept) {
        <div class="confirm-accept">
          <button (click)="accept()" class="confirm-accept-button">
            {{ values.confirm.accept }}
          </button>
        </div>
      }
    </div>
  }
</div>
